<div class="message" *ngIf="!control.valid && (showImmediately || control.dirty || control.touched)">
  {{ message }}
</div>
